// BIO-DATA

export const Bio = {
  name: "Guru Prasad",
  roles: [
    "Software Engineer",
    "Full Stack Developer",
    "Android Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "A versatile individual, always eager to take on new challenges and passionate about learning. Committed to delivering high-quality results with a positive attitude and a growth mindset.",
  github: "https://linktr.ee/guruprasadsahu",
  resume:
    "https://linktr.ee/guruprasadsahu",
  linkedin: "https://www.linkedin.com/in/guruprasadsahu",
  gitlab: "https://github.com/guruprasadsahu",
  twitter: "https://g.dev/guruprasadsahu",
  youtube: "https://www.youtube.com/@guruprasad_sahu",
};

// TECHNICAL-SKILLS

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.vectorlogo.zone/logos/w3_html5/w3_html5-icon.svg",
      },
      {
        name: "CSS",
        image:
          "https://www.vectorlogo.zone/logos/w3_css/w3_css-icon~old.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://www.vectorlogo.zone/logos/javascript/javascript-icon.svg",
      },
      {
        name: "React",
        image:
          "https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg",
      },
      {
        name: "Angular",
        image:
          "https://www.vectorlogo.zone/logos/angular/angular-icon.svg",
      },
      {
        name: "TypeScript",
        image:
          "https://www.vectorlogo.zone/logos/typescriptlang/typescriptlang-icon.svg",
      },
    ],
  },

  {
    title: "Backend",
    skills: [
      {
        name: "C Sharp",
        image: "https://upload.wikimedia.org/wikipedia/commons/b/bd/Logo_C_sharp.svg",
      },
      {
        name: "Dot NET",
        image: "https://www.vectorlogo.zone/logos/dotnet/dotnet-tile.svg",
      },
      {
        name: "Java",
        image: "https://www.vectorlogo.zone/logos/java/java-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://www.vectorlogo.zone/logos/python/python-icon.svg",
      },
      {
        name: "Node Js",
        image: "https://www.vectorlogo.zone/logos/nodejs/nodejs-icon.svg",
      },
      {
        name: "Express Js",
        image:
          "https://www.vectorlogo.zone/logos/azurefunctions/azurefunctions-icon.svg",
      },
    ],
  },

  {
    title: "UI/UX Design",
    skills: [
      {
        name: "Figma",
        image:
          "https://www.vectorlogo.zone/logos/figma/figma-icon.svg",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "https://www.vectorlogo.zone/logos/mui/mui-icon.svg",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
      },
    ],
  },

  {
    title: "Android",
    skills: [
      {
        name: "Ionic",
        image:
          "https://www.vectorlogo.zone/logos/ionicframework/ionicframework-icon.svg",
      },
      {
        name: "Capacitor",
        image:
          "https://www.vectorlogo.zone/logos/ampproject/ampproject-icon.svg",
      },
      {
        name: "XML",
        image:
          "https://cdn-icons-png.flaticon.com/512/9496/9496555.png",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },

  {
    title: "Cloud Database",
    skills: [
      {
        name: "MySQL",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/03/Azure_SQL_cloud_icon.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Mongodb-svgrepo-com.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      // {
      //   name: "AWS",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/5/5c/AWS_Simple_Icons_AWS_Cloud.svg",
      // },
      {
        name: "SQL Server",
        image: "https://upload.wikimedia.org/wikipedia/commons/4/41/Microsoft_SQL_Server_2025_icon.svg",
      },
      {
        name: "Vercel",
        image:
          "https://www.vectorlogo.zone/logos/theverge/theverge-icon.svg",
      },
      {
        name: "Azure",
        image:
          "https://upload.vectorlogo.zone/logos/microsoft_azure/images/e584dc34-9cda-4cd3-b318-b6fe4909e4f8.svg",
      },
      {
        name: "Google Cloud",
        image:
          "https://www.vectorlogo.zone/logos/google_cloud/google_cloud-icon.svg",
      },
      {
        name: "Netlify",
        image:
          "https://www.vectorlogo.zone/logos/netlify/netlify-icon.svg",
      },
    ],
  },

  {
    title: "Version Control",
    skills: [
      {
        name: "Git",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg",
      },
      {
        name: "GitHub",
        image:
          "https://www.vectorlogo.zone/logos/github/github-icon.svg",
      },
      {
        name: "GitLab",
        image:
          "https://www.vectorlogo.zone/logos/gitlab/gitlab-icon.svg",
      },
      {
        name: "Azure Devops",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/f/ff/Azure_DevOps_icon.svg",
      },
      {
        name: "IntelliJ IDEA",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/9/9c/IntelliJ_IDEA_Icon.svg",
      },
      {
        name: "Replit",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/New_Replit_Logo.svg/1200px-New_Replit_Logo.svg.png",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
    ],
  },

  {
    title: "Microsoft Tools",
    skills: [
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/9/9a/Visual_Studio_Code_1.35_icon.svg",
      },
      {
        name: "Visual Studio",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/2/20/Visual_Studio_Icon_2026.svg",
      },
      {
        name: "Microsoft 365",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/0e/Microsoft_365_%282022%29.svg",
      },
      {
        name: "Office 365",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/0c/Microsoft_Office_logo_%282013%E2%80%932019%29.svg",
      },
      {
        name: "Dynamics 365",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/e/e7/Dynamics365-color.svg",
      },
      {
        name: "Power Platform",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/1/1a/Microsoft_Power_Platform_logo.svg",
      },
    ],
  },

  {
    title: "Dynamics 365 CE",
    skills: [
      {
        name: "Sales",
        image:
          "http://dynamicssolution.com/wp-content/uploads/2020/08/Sales.svg",
      },
      {
        name: "Customer Service",
        image:
          "http://dynamicssolution.com/wp-content/uploads/2020/08/Customer-Service.svg",
      },
      {
        name: "Marketing",
        image:
          "http://dynamicssolution.com/wp-content/uploads/2020/08/Marketing.svg",
      },
      {
        name: "Field Service",
        image:
          "http://dynamicssolution.com/wp-content/uploads/2020/08/Field-Service.svg",
      },
      {
        name: "Project Service Automation",
        image:
          "http://dynamicssolution.com/wp-content/uploads/2020/08/Project-Service-Automation.svg",
      },
    ],
  },

  {
    title: "Power Platform",
    skills: [
      {
        name: "Power Apps",
        image:
          "https://static.wixstatic.com/media/3536c6_9a603c25269f487ea90f625775c5e2d8~mv2.png/v1/fill/w_156,h_156,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/PowerAppIcon.png",
      },
      {
        name: "Dataverse",
        image:
          "https://www.pngall.com/wp-content/uploads/17/Dataverse-Logo-Digital-Emblem-PNG.png",
      },
      {
        name: "Power Pages",
        image:
          "https://static.wixstatic.com/media/3536c6_94c3e33c43b3448bb484a952542718e9~mv2.png/v1/fill/w_156,h_156,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/PowerPages.png",
      },
      {
        name: "Power BI",
        image:
          "https://static.wixstatic.com/media/3536c6_f210c9c3a5944ec7b661ea14900d6588~mv2.png/v1/fill/w_156,h_156,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/PowerBI.png",
      },
      {
        name: "Power Automate",
        image:
          "https://static.wixstatic.com/media/3536c6_5c83e0e808aa41c194ecec6e933a31c2~mv2.png/v1/fill/w_156,h_156,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/PowerAutomate.png",
      },
      {
        name: "Power Fx",
        image:
          "https://static.wixstatic.com/media/816382_bd664a10b4ec4239b7f9739dbd210863~mv2.png/v1/fill/w_420,h_420,al_c,lg_1,q_85/816382_bd664a10b4ec4239b7f9739dbd210863~mv2.png",
      },
      {
        name: "Copilot Studio",
        image:
          "https://a.fsdn.com/allura/s/power-virtual-agents/icon?2870d8956e754b3cbe5f40fe2072d58e6cbcb872413cebf4b5b99e2d410f790a?&w=222",
      }, 
      {
        name: "AI Builder",
        image:
          "https://static.wixstatic.com/media/3536c6_4a6b599bcd89434e820c464274e3884a~mv2.png/v1/fill/w_156,h_156,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/AIBuilder.png",
      },
    ],
  },

    {
    title: "AI Tools",
    skills: [
      {
        name: "Claude Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/b/b0/Claude_AI_symbol.svg",
      },
      {
        name: "Perplexity",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/b/b5/Perplexity_AI_Turquoise_on_White.png",
      },
      {
        name: "ChatGPT",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/archive/0/04/20230903231117%21ChatGPT_logo.svg",
      },
      {
        name: "Gemini",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/1/1d/Google_Gemini_icon_2025.svg",
      },
      {
        name: "Copilot",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/archive/0/0e/20231004051713%21Microsoft_365_%282022%29.svg",
      },
      {
        name: "Antigravity",
        image:
          "https://brandlogos.net/wp-content/uploads/2025/12/google_antigravity-logo_brandlogos.net_qu4jc-768x708.png",
      },
      {
        name: "Cursor",
        image:
          "https://www.vectorlogo.zone/logos/getblockio/getblockio-icon.svg",
      },
      {
        name: "Lovable",
        image:
          "https://raw.githubusercontent.com/lobehub/lobe-icons/refs/heads/master/packages/static-png/light/lovable-color.png",
      },
      {
        name: "MidJourney",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/a/a7/Midjourney_Emblem_%28in-colour%29.svg",
      },
      {
        name: " Microsoft Designer",
        image:
          "https://play-lh.googleusercontent.com/80aI7JXWoNyBxh4VQBoPqwXtesr7JMq5-3J-LkVWhMnpaP1P8PkqkDpiK_--W23GvDo",
      },
    ],
  },
];

// EXPERIENCE

export const experiences = [
  {
    id: 0,
    img: "https://scontent.fbbi1-2.fna.fbcdn.net/v/t39.30808-1/276992517_116638810971228_1810537514337266623_n.jpg?stp=dst-jpg_s200x200_tt6&_nc_cat=105&ccb=1-7&_nc_sid=2d3e12&_nc_ohc=dnOVM0C3DsAQ7kNvwEkd-bd&_nc_oc=AdqYrmsPW8zlj-_MC4LiYclR0y8RY4mIqIiXxx-Xm_OgLEqI8yus33vyto_ulDKDWwFpZVb3oURg5kc0wZikyXD4&_nc_zt=24&_nc_ht=scontent.fbbi1-2.fna&_nc_gid=d57ZXBvEIYfB-fkFRQmWqA&_nc_ss=7a30f&oh=00_Afw0veD5YUv-YjD9f2nW8dgugUEnT4CQqGEO4CvL_Nr-_Q&oe=69C43A0F",
    role: "Software Development Engineer",
    company: "Logyscal Soutions Pvt. Ltd.",
    date: "November 2023 - Present",
    desc: "I have joined Logyscal Soutions as a Software Developement Engineer. I have involved in the Design User Interfaces and Development of Web applications, Mobile applications and Business applications to solve real-life problems.",
    skills: [
      "OOPs",
      "Kotlin",
      "XML",
      "Figma",
      "JavaScript",
      "jQuery",
      "Bootstrap",
      "Firebase",
      "Android Studio",
      "Git",
      "GitLab",
      "SQL Server",
      "C#",
      "ASP.NET",
      "WebAPI",
      "Microsoft Azure",
      "DevOps",
      "Dynamics 365",
      "Power Platform"
    ],
    // doc: "https://logyscal.com/",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmOHG99Gglye2L1mfmZe9aEFe9cY5v2Mf6hg&s",
    role: "Cloud Community Member",
    company: "GDSC & GDG Cloud Bhubaneswar",
    date: "January 2022 - Present",
    desc: "I have joined Google Developer Students Club and Google Developers Group as a Cloud Community Member. I had the opportunity to gain invaluable hands-on experience in the Google Cloud Platform and other recent technologies from Google. I got an opportunity to attend Google I/O 2023.",
    skills: [
      "Android Studio",
      "XML",
      "Kotlin",
      "Jetpack Compose",
      "Firebase"
    ],
    // doc: "https://g.dev/guruprasadsahu",
  },
  {
    id: 2,
    img: "https://scontent.fbbi1-2.fna.fbcdn.net/v/t39.30808-1/299386529_430324439114462_3703906515898446064_n.jpg?_nc_cat=108&ccb=1-7&_nc_sid=2d3e12&_nc_ohc=bmWgpUJrfjYQ7kNvwFTHV9A&_nc_oc=Adp5-Kbr3z-55Hj3-qpMOaJS_JdAwYY88SswATY57sfPHhPznJ7o1csaJuLpg_DicL882tTL9oCgfSFUMtTMGkY6&_nc_zt=24&_nc_ht=scontent.fbbi1-2.fna&_nc_gid=16rjQyZPLmIUwqJ8wJ5obw&_nc_ss=7a30f&oh=00_Afxz-Q5dfq057GXsYRXQQKRBN07mbku4URxOt07Q4PxCLw&oe=69C431DA",
    role: "Software Developer Trainee",
    company: "Ajatus Software Pvt. Ltd.",
    date: "May 2023 - October 2023",
    desc: "I have joined Ajatus Software as a Software Developer Trainee. I was involved in the design user interfaces and development of web applications, mobile applications, business applications and admin dashboards to solve real-life problems. I have designed the user interface for mobile applications, websites, web applications and admin dashboards.",
    skills: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "TypeScript",
      "React Js",
      "Angular",
      "Node Js",
      "Express Js",
      "MongoDB",
      "Atlas",
      "Figma",
      "Penpot",
      "Ionic",
      "Capacitor",
    ],
    // doc: "https://recyclepay.ceibagreen.com/",
  },
  {
    id: 3,
    img: "https://ih1.redbubble.net/image.4713585318.4961/st,small,507x507-pad,600x600,f8f8f8.jpg",
    role: "AI - ML Intern",
    company: "AWS Acadmy",
    date: "March 2023 - May 2023",
    desc: "As an AI-ML Intern at AWS Academy, I am gaining valuable hands-on experience in the exciting world of artificial intelligence and machine learning,  while also learning how to harness AWS services to streamline AI and ML workflows. This role has provided me with a unique opportunity to deepen my knowledge of AI and ML concepts, sharpen my coding skills, and apply my analytical abilities to real-world problems. I am continually learning and growing in a dynamic environment where innovation and collaboration are highly encouraged. I am excited to be part of a team that is dedicated to pushing the boundaries of what AI and ML can achieve, all while benefiting from the vast resources and expertise offered by AWS Academy.",
    skills: [
      "Artificial Intelligence",
      "Machine Learning",
    ],
    // doc: "https://drive.google.com/file/d/1prww-4_vsLLszY5_R5PfQZEEE3GvEDBQ/view?usp=sharing",
  },
  {
    id: 4,
    img: "https://static.mygov.in/media/blog/2022/11/CaptureG20.png",
    role: "Student Volunteer",
    company: "G20 Summit India 2023",
    date: "January 2023 - February 2023",
    desc: "As a Student Volunteer at the G20 Summit 2023 on the Future of Work, Science & Technology, I played a pivotal role in supporting this globally significant event. My responsibilities included assisting in event, engaging with renowned experts and leaders, and facilitating discussions on the future of work, science, and technology. This unique opportunity allowed me to gain valuable insights, network with influential figures, and contribute to shaping global policy conversations. It was a transformative experience that enriched my understanding of these critical domains while reinforcing my commitment to addressing the challenges and opportunities they present on a global scale.",
    skills: [
      "Science",
      "Technology",
    ],
    // doc: "https://drive.google.com/file/d/1qowHOHuIFcHtYwGeHPad1X9LL80KH8us/view?usp=sharing",
  },
  {
    id: 5,
    img: "https://ih1.redbubble.net/image.4713585318.4961/st,small,507x507-pad,600x600,f8f8f8.jpg",
    role: "Data Analytics Intern",
    company: "AWS Acadmy",
    date: "July 2022 - September 2022",
    desc: "During my time as a Data Analytics Intern at AWS Academy, I had the invaluable opportunity to immerse myself in the world of cloud computing and data analysis. This experience provided me with hands-on exposure to cutting-edge technologies and best practices in the field. I actively collaborating with a dynamic team of professionals to harness the power of AWS services for data analysis and interpretation. This internship not only enhanced my technical skills but also deepened my understanding of the cloud computing landscape, setting the stage for a promising future in the field of data analytics.",
    skills: [
      "Amazon Web Services",
      "Data Analytics",
      "Cloud Computing",
    ],
    // doc: "https://drive.google.com/file/d/1xyBDs7USlHF2qlB2dLM8-EphRfe5HiB2/view?usp=sharing",
  },
  {
    id: 6,
    img: "https://images.ctfassets.net/ajuyecyagjo7/4A23Wo3eqKrcd0HEN3uFNe/e811019b19915946e917e64be946b504/eyJidWNrZXQiOiJnZHAtc2l0ZSIsImtleSI6ImF0dGFjaG1lbnRzL2Nra2Q1NzV4bjAwMmJ1OGI0NWI0cTM4YTctcGFudy1sb2dvLTJ1cC0wMS5wbmciLCJlZGl.webp",
    role: "Cyber Security Intern",
    company: "Palo Alto Networks",
    date: "March 2022 - May 2022",
    desc: "As a Cyber Security Intern at Palo Alto Networks, I had the opportunity to gain invaluable hands-on experience in the dynamic field of cybersecurity. Throughout my internship, I had the chance to immerse myself in cutting-edge technologies and tools, further developing my skills in threat detection, incident response, and security analysis. This internship provided me with a strong foundation in cybersecurity practices and an inside look at the innovative solutions that Palo Alto Networks delivers to safeguard organizations from ever-evolving cyber threats.",
    skills: [
      "Cyber Security",
      "Network Security",
      "Cloud Security",
    ],
    // doc: "https://drive.google.com/file/d/1fZ2dy6KLHK-re-eq86u8vVL7na4ZQryt/view?usp=sharing",
  },
  {
    id: 7,
    img: "https://cse.noticebard.com/wp-content/uploads/sites/23/2023/08/Smart-India-Hackathon-2023.jpg",
    role: "Hackathon Participant",
    company: "Smart India Hackathon 2022", 
    date: "January 2022 - February 2022",
    desc: "In 2022, I had the exciting opportunity to participate in the Smart India Hackathon through my college. Our team embarked on an innovation journey, culminating in the creation of an innovative web application. This application is tailor-made to transform the conventional tender bidding and selling process, ushering in a new era of efficiency and convenience in this crucial domain.",
    skills: [
      "Problem Solving",
      "Python",
      "HTML",
      "CSS",
      "JavaScript",
      "Tailwind CSS",
    ],
  },
];

// EDUCATION

export const education = [
  {
    id: 0,
    img: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource211/v4/5b/06/5a/5b065a86-3d30-147b-e24d-efd0555327c9/Placeholder.mill/1200x630wa.jpg",
    school: "Softchief Learn Pvt. Ltd., Bhubaneswar, Odisha",
    date: "2023 - Present",
    grade: "Microsoft Dynamics365 CE, Power Platform, C#, ASP Dot NET, SQL Server, Azure",
    desc: "I have completed professional training for Dynamics365 CE Techno-Functional Consultant from Softchief Learn Pvt. Ltd., Bhubaneswar, Odisha. I have taken courses like Microsoft Dynamics365 CE, Power Platform, C#, ASP Dot NET, jQuery, Entity Framework, SQL Server, Azure, Devops etc, where I have learned and worked on exciting projects with a team of talented developers.",
    degree: "Dynamics365 CE Techno-Functional Consultant",
  },
  {
    id: 1,
    img: "https://scontent.fbbi5-1.fna.fbcdn.net/v/t39.30808-1/306532379_400122595614454_7140997368893721840_n.png?stp=c4.0.312.312a_dst-png_s200x200&_nc_cat=110&ccb=1-7&_nc_sid=2d3e12&_nc_ohc=JQCLTiEuP_oQ7kNvwHeS5N5&_nc_oc=AdpOZ0OXHTcSwQgbPfjkGf0yDlMkn-jeIOGBbYzd_Jn2v8UZBDIJByVxWXyNwfJDCSCCf3NyhUClEXLWA4ZIwzqh&_nc_zt=24&_nc_ht=scontent.fbbi5-1.fna&_nc_gid=stozur_5w_0Ujlkf4rTI2g&_nc_ss=7a30f&oh=00_Afxo53ELx3rYgAXun_Cam5wN47w2hbACUuxdZLWAGx5SEA&oe=69C43F72",
    school: "Biju Patnaik University of Technology, Odisha",
    date: "2021 - 2023",
    grade: "8.78 CGPA",
    desc: "I have completed a Master's degree inComputer Applications (MCA) from Biju Patnaik University of Technology, Bhubaneswar. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, Cloud Computing and Computer Networks, among others. I am also a member of the Google Developers Student Club, where I have learned and worked on exciting projects with a team of talented developers.",
    degree: "MCA - Master of Computer Applications",
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/v2/D560BAQHWwrqpaWE2_w/company-logo_200_200/company-logo_200_200/0/1711035967841?e=2147483647&v=beta&t=MkDExryDy7MRwZMfN2Gu_hhcgvsmyGY0sQ8HiTLgsVw",
    school: "Berhampur University, Berhampur, Odisha",
    date: "2018 - 2021",
    grade: "9.20 CGPA",
    desc: "I have completed a Bachelor's degree in Computer Science as Honours subject from Berhampur University, Berhampur. I have secured the position of RANK-5 in the University.",
    degree: "Bachelor of Science (Honrs) - Computer Science",
  },
  {
    id: 3,
    img: "data:image/jpeg;base64,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",
    school: "Gyana Vikash Junior College, Berhampur, Odisha",
    date: "2016 - 2018",
    grade: "Science & Information Technology",
    desc: "I have completed my Class 12th education from Gyana Vikash Junior College, Berhampur. There I learned Physics, Chemistry, Mathematics & Information Technology.",
    degree: "CHSE(XII), Science & Information Technology",
  },
  {
    id: 4,
    img: "https://scontent.fbbi5-3.fna.fbcdn.net/v/t39.30808-1/461199697_1062356839223752_6390104465399926081_n.jpg?stp=dst-jpg_s200x200_tt6&_nc_cat=100&ccb=1-7&_nc_sid=2d3e12&_nc_ohc=eV5ko3QfnAsQ7kNvwGTHRm5&_nc_oc=AdpWyL8hLAv7MYMspLi2c2kBsUT0MHsoy4Fbm4bj2uVCJ8UO17yhEaSkkujmSVcUe4EgVeGHBVXZIoU0-3L46GLY&_nc_zt=24&_nc_ht=scontent.fbbi5-3.fna&_nc_gid=TACaerG5KqtFj1391At06w&_nc_ss=7a30f&oh=00_Afw-UtEwQXGErNosNId4h0ZssCkoH-7IKB0lXfTLcpb9Vg&oe=69C43807",
    school: "Sai Gurukul School, Bhanjanagar, Odisha",
    date: "2013 - 2016",
    grade: "General, Social, Physical & Spiritual Science",
    desc: "I have completed my Class 10th education from Sai Gurukul School, Bhanjanagar. There I learned Physical Science, Material Science, Life Science, Social Science, Mathematics, Literature, Yoga & different languages.",
    degree: "BSE(X), General & Social Science",
  },
  {
    id: 4,
    img: "https://sriaurobindoschool.com/wp-content/uploads/2022/04/sri-aurobindo-integral-education-bhubaneswar-1.png",
    school: "Sri Aurobindo Integral Education Centre, Odisha",
    date: "2003 - 2013",
    grade: "General, Social, Physical & Spiritual Science",
    desc: "I have completed my Nursery, K.G. and Class:(I to VII) education from Sri Aurobindo Integral Education Centre, Jagannath Prasad, Ganjam. Odisha. There I learned General Science, Physical Science, Life Science, Social Science, Spiritual Science, Mathematics, Literature, Yoga & different languages.",
    degree: "Nursery, K.G., Class:(I - VII)",
  },
];

// PROJECTS

export const projects = [
  {
    id: 9,
    title: "Medinova Hospital",
    date: "February 2023 - March 2023",
    description:
      "Medinova is a comprehensive software solution that allows patients to conveniently book appointments with doctors for medical checkup.In this software, patients can easily register, browse doctors based on their specialization, and book appointments online. The system sends notifications and reminders to ensure patients don't miss their scheduled checkups. During the visit, doctors can access patient records, perform examinations, and provide prescriptions, ensuring efficient healthcare delivery.",
    image:
      "https://cdn.dribbble.com/userupload/10620470/file/original-1222b78787e0a1161238b10e0d45a52e.jpg?resize=1024x800",
    tags: ["HTML", "CSS", "JavaScript", "SCSS", "Bootstrap", "Tailwind CSS"],
    category: "web app",
    github: "https://github.com/guruprasad9610/Medinova_Hospital",
    webapp: "https://medinovahospital.netlify.app/",
  },
  
  {
    id: 2,
    title: "The Fabric Store",
    date: "May 2023 - June 2023",
    description:
      "A fully responsive e-commerce website for selling Fabrics. It offers a variety of textiles for different purposes, from apparel to home decor. Customers can browse, select, and purchase fabrics with ease.",
    image:
      "https://www.templatemonster.com/blog/wp-content/uploads/2020/04/thread-and-needle-modern-shopify-theme.jpg",
    tags: ["HTML", "CSS", "JavaScript", "SCSS", "Bootstrap", "Tailwind CSS", "Material UI"],
    category: "business website",
    github: "https://github.com/guruprasad9610/Fabric_Store",
    webapp: "https://aifabricstore.netlify.app/",
  },

  {
    id: 7,
    title: "Contact Manager App",
    date: "July 2023 - August 2023",
    description:
    "Efficiently organize your contacts on the go with our Contact Management Mobile App! Seamlessly manage and categorize your contacts, schedule meetings, and stay connected with ease. Enjoy intuitive user-friendly design, customizable fields, and robust search capabilities. Synchronize effortlessly with your device's address book. Plus, safeguard your data with secure backup options. Streamline your social and professional networks in one convenient hub.",
    image:
      "https://cdn.dribbble.com/users/1237425/screenshots/6296599/contacts.png",
    tags: ["React", "Redux", "Tailwind CSS", "Firebase", "JavaScript", "TypeScript", "Android Studio"],
    category: "android app",
    github: "https://github.com/guruprasad9610/Contact_Management_App",
    webapp: "https://contact-management-app-teal.vercel.app/",
  },

  {
    id: 10,
    title: "Task Manager App",
    date: "June 2023 - July 2023",
    description:
      "Task manager application is a simple and efficient task management application developed using the Angular and Ionic framework. This single page application provides users with an intuitive and user-friendly interface to organize and keep track of their daily tasks, to-do items, and important deadlines. This app will help stay on top of your tasks and boost productivity.",
    image:
      "https://cdn.dribbble.com/users/2128942/screenshots/13941478/media/bba18671f8fbcc7fe8993d342e1c459c.png?resize=1000x750&vertical=center",
    tags: ["Bootstrap", "Angular", "TypeScript", "Ionic", "Capacitor", "JSON Server", "Android Studio"],
    category: "android app",
    github: "https://github.com/guruprasad9610/Task_Manager_Application",
    webapp: "https://taskmanagerangular.netlify.app/",
  },

  {
    id: 12,
    title: "Beats Music Headphones",
    date: "April 2022 - May 2022",
    description:
      "An e-commerce platform that offers the users to browse and purchase high-quality headphones. The site is designed to provide an exceptional user experience.",
    image:
      "https://cdn.dribbble.com/users/4517033/screenshots/15681068/media/4261e38544c6c0243f0ee6ce684a84a1.jpg?resize=1000x750&vertical=center",
    tags: ["HTML", "CSS", "JavaScript", "SCSS", "Bootstrap"],
    category: "business website",
    github: "https://github.com/guruprasad9610/Beats_Music",
    webapp: "https://beatsmusichead.netlify.app/",
  },

  {
    id: 13,
    title: "Seabeach Travel",
    date: "August 2022 - September 2022",
    description:
      "A tourism website to explore the beauty of coastal paradise and discover pristine shores, hidden gems at seasore.",
    image:
      "https://cdn.dribbble.com/userupload/5487034/file/original-cb1ccdaf0d4fe3ade370c502fd6bb143.png?resize=1200x882",
    tags: ["HTML", "CSS", "JavaScript", "SCSS", "Bootstrap"],
    category: "business website",
    github: "https://github.com/guruprasad9610/SeaBeach_Travel",
    webapp: "https://seabeachtravel.netlify.app/",
  },

  {
    id: 14,
    title: "Time Heist Watches",
    date: "June 2022 - July 2022",
    description:
      "An e-commerce website offers a curated selection of exquisite timepieces, meticulously crafted for connoisseurs of style and precision. Explore a world of luxury, where quality meets sophistication, and choose from an array of prestigious brands. From classic to contemporary, our watches make a statement. Elevate your wrist game and shop with confidence on our platform, where luxury is just a click away.",
    image:
      "https://cdn.dribbble.com/userupload/4394964/file/original-cd577f267fd6820744257bdbb91b5a15.png?resize=1200x900",
    tags: ["HTML", "CSS", "JavaScript", "SCSS", "Bootstrap"],
    category: "business website",
    github: "https://github.com/guruprasad9610/TimeHeist_Watches",
    webapp: "https://timeheist.netlify.app/",
  },

  {
    id: 11,
    title: "FLUX Digital Agency",
    date: "December 2022 - January 2023",
    description:
      "Flux is a business website for a startup organization based on digital marketing agency. This dynamic and user-friendly website, featuring cutting-edge SEO optimization, engaging content, and seamless user experience. Take your business to new heights with our open-source solutions, empowering you to conquer the digital landscape. Unlock the potential of your brand with our expertly coded website, where innovation meets results.",
    image:
      "https://cdn.dribbble.com/users/4854826/screenshots/16042184/media/6b00067fd2cd7c04317c3a5ec79d7d4e.png?resize=1000x750&vertical=center",
    tags: ["HTML", "CSS", "JavaScript", "SCSS", "Bootstrap", "Tailwind CSS"],
    category: "business website",
    github: "https://github.com/guruprasad9610/Flux_Digital_Agency",
    webapp: "https://flux-org.netlify.app/",
  },

  {
    id: 1,
    title: "Tender Wave",
    date: "December 2021 - January 2022",
    description:
      "TanderWave is an innovative online platform specifically designed to revolutionize the tender bidding and selling process. This dynamic website is built using cutting-edge technologies such as HTML5, TailwindCSS, JavaScript, and SQL, TanderWave offers a user-friendly and efficient way for businesses and individuals to engage in transparent and competitive tender transactions.",
    image:
      "https://cdn.dribbble.com/users/1520198/screenshots/15799619/media/0fe364bcd75724ebb1d105ad49548223.png?resize=800x600&vertical=center",
    tags: ["HTML", "CSS", "JavaScript", "SCSS", "Bootstrap", "Tailwind CSS"],
    category: "web app",
    github: "https://github.com/guruprasad9610/Tender_Wave",
    webapp: "https://tenderwave.netlify.app/",
  },

  {
    id: 3,
    title: "Movie Recomendation App",
    date: "September 2023 - October 2023",
    description:
      "This project is a mobile app designed to provide you with personalized movie recommendations based on your preferences. Built using Angular, Ionic Framework, and Android Studio, it offers a seamless and engaging user experience for movie enthusiasts.",
    image:
      "https://cdn.dribbble.com/users/316986/screenshots/6416649/nam_watcha1_4x.png?resize=1000x750&vertical=center",
    tags: ["Materila UI", "Angular","TypeScript", "Ionic", "Capacitor", "Firebase", "Android Studio"],
    category: "android app",
    github: "https://github.com/guruprasad9610/Movie_App_Ionic",
    webapp: "https://github.com/guruprasad9610/Movie_App_Ionic",
  },

  {
    id: 8,
    title: "Shoe Gallery",
    date: "February 2022 - March 2022",
    description:
      "Shoe Gallery is a web-based e-commerce platform designed to make your online shoe shopping experience easy, convenient, and enjoyable. Whether you're a shoe enthusiast or just looking for the perfect pair, our platform offers a wide range of footwear options to suit your style and needs.",
    image:
      "https://cdn.dribbble.com/userupload/10506941/file/original-45b983a6949da5e13fc63314916c4eb0.png?resize=1024x768",
    tags: ["HTML", "CSS", "JavaScript", "SCSS", "Bootstrap"],
    category: "business website",
    github: "https://github.com/guruprasad9610/Shoe_Gallery",
    webapp: "https://shoegallery.netlify.app/",
  },

  {
    id: 5,
    title: "Employe Management S/w",
    date: "August 2023 - September 2023",
    description:
      "Employee Management Software is a versatile and user-friendly application designed to simplify and streamline the process of managing employees within your organization. Whether you are a small business owner or part of a larger enterprise, this software offers a comprehensive set of features to help you efficiently manage your workforce.",
    image:
      "https://cdn.dribbble.com/users/1726280/screenshots/12579027/media/a0f18d9edca0aa081c4bfd6970b5d549.jpg?resize=1000x750&vertical=center",
    tags: ["Material UI", "JavaScript", "Angular","TypeScript", "Node.js", "MongoDB", "Express.js", "JWT", "NodeMailer"],
    category: "web app",
    github: "https://github.com/guruprasad9610/Employee_Management_MEAN-stack",

    webapp: "https://github.com/guruprasad9610/Employee_Management_MEAN-stack",
  },

  {
    id: 6,
    title: "Role based Authentication",
    date: "July 2023 - August 2023",
    description:
      "An software application which contains multiple user's role based signup, login authnitication with email & password with login session using JWT developed using the MEAN stack.",
    image:
      "https://cdn.dribbble.com/users/2322899/screenshots/14216498/media/0151175f6644c6d68f3275a1ce28ea4a.jpg?resize=1000x750&vertical=center",
    tags: ["Bootstrap", "JavaScript", "Angular","TypeScript", "Node.js", "MongoDB", "Express.js", "JWT"],
    category: "web app",
    github: "https://github.com/guruprasad9610/Role_based_Authnitication",
    webapp: "https://github.com/guruprasad9610/Role_based_Authnitication",
  },

  {
    id: 4,
    title: "Hospital Management S/w",
    date: "April 2023 - May 2023",
    description:
      "Hospital Management System is a comprehensive and user-friendly software solution designed to streamline and automate various administrative and clinical processes within a healthcare facility. This open-source project is dedicated to improving the efficiency and effectiveness of hospitals, clinics, and healthcare centers worldwide. This system simplifies and automates tasks related to patient management, appointment scheduling, billing, and more, enabling healthcare providers to focus on delivering quality patient care.",
    image:
      "https://cdn.dribbble.com/userupload/10616121/file/original-62168fb8335fc934d6c142c6e2e5a686.png?resize=1024x768",
    tags: ["HTML", "CSS", "JavaScript", "SCSS", "Bootstrap", "PHP", "MySQL"],
    category: "web app",
    github: "https://github.com/guruprasad9610/Hospital_Management_System",
    webapp: "https://github.com/guruprasad9610/Hospital_Management_System",
  },

  {
    id: 0,
    title: "User Login & Signup, Forget & Reset Password",
    date: "July 2023 - August 2023",
    description:
      "An software application which contains User's signup, login authnitication with email & password, forget & reset password using Node-mailer with login session & password reset link expiry using JWT developed using the MEAN stack.",
    image:
      "https://cdn.dribbble.com/users/1306406/screenshots/5461796/media/a809a92c5372f562c2ab5570cf602965.jpg?resize=1000x750&vertical=center",
    tags: ["Bootstrap", "JavaScript", "Angular","TypeScript", "Node.js", "MongoDB", "Express.js", "JWT", "NodeMailer"],
    category: "web app",
    github: "https://github.com/guruprasad9610/Forget_Reset_Password_JWT",
    webapp: "https://github.com/guruprasad9610/Forget_Reset_Password_JWT",
  },



];

// DEV-JOURNEY TIMELINE

export const TimeLineData = [
  { year: 2018, text: "Started my journey from BSc(H)-CS" },
  { year: 2019, text: "Got knowledge about different programming languages" },
  { year: 2020, text: "Got hands-on experience to develope websites" },
  { year: 2021, text: "Completed BSc(H)-CS and Secured RANK-5 in University & joined MCA" },
  { year: 2022, text: "Worked in different organizations as an intern" },
  { year: 2023, text: "Completed MCA and Started my journey as a Fullstack Software Developer in a S/w co." },
];
